import {h} from 'preact';
import {useEffect, useRef, useState} from "preact/compat";
import {randomFromInterval} from "../../helper";

export const incrementSpeed = 10;

/**
 *
 * @returns {JSX.Element}
 * @constructor
 */
const FileInputInnowaveProgress = ({progress = 0, failed = false}) => {

    const [ownProgress, setOwnProgress] = useState(progress);
    const [changeInterval, setChangeInterval] = useState(null);

    // create ref for callback
    const ownProgressRef = useRef(null);
    ownProgressRef.current = ownProgress;

    useEffect(() => {
        // first clear the interval and set new
        clearInterval(changeInterval);
        // find difference
        const difference = progress - ownProgress;
        if (difference > 0) {
            setChangeInterval(
                setInterval(() => {
                    let percent = difference / (progress === 100 ? 1000 : 3000);
                    // add some random
                    percent = randomFromInterval(percent / (progress === 100 ? 3 : 100), percent * 3);
                    // save state
                    setOwnProgress(Math.min(ownProgressRef.current + percent * incrementSpeed, 100));
                }, incrementSpeed)
            )
        }
    }, [progress]);

    useEffect(() => {
        // just stop it when finished
        if (ownProgress >= progress) {
            clearInterval(changeInterval);
        }
    }, [progress, ownProgress]);

    const title = ownProgress < 100 && !failed ? 'Выполняется обработка документа...' : 'Завершено';

    return (
        <div className="file-input__progress">
            <div className="file-input__progress__background">
                {/* so the idea is to put titles at the same place, it gives cool effect */}
                <span className={'file-input__progress__title'}>{title}</span>
                <div style={{width: `${ownProgress}%`}} className="file-input__progress__inner">
                    {/* this bad boy is hidden and visible only when progress is big enough */}
                    <span className={'file-input__progress__title'}>{title}</span>
                </div>
            </div>
            <div className="file-input__progress__indicator">
                {Math.floor(ownProgress)}%
            </div>
        </div>
    )
}

export default FileInputInnowaveProgress